import { getPlatform, Platforms } from '@cloudnoa/cloud-platform'

const platform = Object.assign({}, getPlatform(window.servicePlatform))
Platforms.forEach((p) => {
  platform[`is${p.capitalizedId}`] = p.id === platform.id
})

export default {
  service: {
    platform: window.servicePlatform,
    env: window.serviceEnv,
  },

  platform,

  title: {
    text: `HyperBilling for ${platform.shortName}`,
    suffix: '',
  },

  logo: {
    dir: '/img/logo',
    filename: `${platform.id}.png`,
    alt: `HyperBilling for ${platform.name}`,
  },

  api: {
    baseUri: '/api',
  },

  router: {
    mode: 'history',
  },

  serviceStartDate: '2019-01-01',

  feature: {
    project: true,
    tags: true,
    creditAlarm: true,
    budgetAlarm: true,
    reseller: false,
    report: false,
    costByRegion: true,
    costByCountry: false,
    creditKind: false,
    pricingUnit: false,
    showExchangeRate: true,
    showProjectId: false,
    accountBalance: false,
    accountText: 'account',
    projectText: 'project',
    globalCorporation: false,
  },

  topNavigation: {
    showAccountId: false,
    minAccountForSearch: 10,
    minAccountForPin: 20,
  },

  invoice: {
    title: platform.shortName,

    billone: {
      // 빌원 인보이스를 고객에게 보여줄 첫 청구월 (YYYY-MM).
      // 그 이전 달은 hb2 가 이미 발행했으므로 겹쳐 보이면 안 된다.
      // null 이면 제한하지 않는다 — 검증 환경에서 전 기간을 본다.
      //
      // **값은 CSP 별로 `platform/{csp}.js` 에서 정한다** (BO-3681).
      // 여기에 실제 월을 두면 한 값이 CSP 6개에 공유돼, 전환 시점이 다른 CSP 가
      // 붙을 때 먼저 이관한 쪽 기준이 그대로 딸려간다.
      //
      // 여기가 null 이어도 이관하지 않은 CSP 는 영향이 없다 — 빌원 조회 자체를
      // 안 한다 (`Invoice.vue` 의 BILLONE_ENABLED_PLATFORMS 화이트리스트).
      // 반대로 **화이트리스트에 CSP 를 추가할 때는 그 CSP 의 firstMonth 를 반드시
      // 함께 넣어야 한다** — 빠뜨리면 hb2 가 이미 발행한 달까지 겹쳐 보인다.
      firstMonth: null,
    },
  },

  billing: {
    root: window.location.origin,

    summary: {
      dataPresentHours: 5.5 + 24, // 한국 시간 기준 오후 2시 30분 (UTC 5시 30분) 이후에 하루전 데이터가 존재한다고 가정함
      dataCompleteHours: 5.5 + 48, // 한국 시간 기준 오후 2시 30분 (UTC 5시 30분) 이후에 이틀 전 데이터가 완전하다고 가정함
      maxRegressionWindow: 30, // 선형 회귀에 사용할 최대 데이터 수
      minRegressionWindow: 3, // 선형 회귀에 사용할 최소 데이터 수

      costShareItems: [
        'costByCountry',
        'costByRegion',
        'costByProject',
        'costByService',
      ],
    },

    dataTransfer: {
      enabled: true,
    },

    costPivot: {
      excludeFields: [],
    },

    cdn: {
      enabled: true,
    },

    consolidated: {
      enabled: true,
    },

    commitmentAnalysis: {
      enabled: false,
    },
    costTable: {
      enabled: false,
    },
  },

  personal: {
    ipAccessControl: {
      enabled: false,
    },
  },

  admin: {},

  reseller: {
    enabled: false,
  },

  socket: {
    uri: '/',

    option: {
      path: '/api/socket/worker',
      transports: ['websocket'],
      timeout: '30000',
    },

    event: {
      worker: 'workerService',
    },
  },

  megazoneAccount: {
    url: 'https://start.megazone.com/',
  },

  storage: {
    billing: {
      path: `/${platform.id}/billing/`,
    },
  },

  exchangeRate: {
    default: 'USD',
  },

  languages: {
    default: 'ko',

    korean: {
      enabled: true,
      name: 'korean',
      value: 'ko',
    },
    english: {
      enabled: true,
      name: 'english',
      value: 'en',
    },
  },

  currencies: {
    default: 'KRW',

    krw: {
      enabled: true,
      name: 'krw',
      value: 'KRW',
      unit: '₩',
    },
    usd: {
      enabled: true,
      name: 'usd',
      value: 'USD',
      unit: '$',
    },
    cny: {
      enabled: false,
      name: 'cny',
      value: 'CNY',
      unit: '¥',
    },
    jpy: {
      enabled: false,
      name: 'jpy',
      value: 'JPY',
      unit: '¥',
    },
  },

  bq: {
    accounts: [],
  },

  corporations: {
    international: {
      enabled: false,
      name: 'international',
      value: 'international',
      ordering: 1,
    },
    china: {
      enable: false,
      name: 'china',
      value: 'china',
      ordering: 2,
    },
    hongkong: {
      enabled: false,
      name: 'hongkong',
      value: 'hongkong',
      ordering: 3,
    },
    australia: {
      enabled: false,
      name: 'australia',
      value: 'australia',
      ordering: 4,
    },
  },

  timezone: 'UTC',

  ga: {
    hasGoogleAnalytics: false,
    trackingId: window.trackingId || '',
  },
}
